import { pathConfig } from "../fetchNexusConfig";
export const sendLog = (content, pathConfigOverride) => {
    var _a, _b;
    const clientapiroot = (_b = (_a = pathConfigOverride === null || pathConfigOverride === void 0 ? void 0 : pathConfigOverride.clientapiroot) !== null && _a !== void 0 ? _a : pathConfig === null || pathConfig === void 0 ? void 0 : pathConfig.clientapiroot) !== null && _b !== void 0 ? _b : "";
    if (clientapiroot === "") {
        return;
    }
    const queryString = new URLSearchParams(document.location.search);
    const log = "[APEX]: " + content + " :: " + queryString.toString();
    const logObject = {
        log
    };
    fetch(clientapiroot + "/capi/2.0/casino/launchlog", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(logObject)
    }).catch((fetchError) => {
        console.error("Failed to send log", fetchError);
    });
};
